module.exports = __webpack_public_path__ + "img/YNGConnectGroups.6d5cbd9c.svg";